import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const socialActions = [
  {
    title: 'Friends',
    href: '/dashboard/friends',
    description: 'Manage accepted friends who can see friends-only profile components and entries.',
    action: 'Manage friends',
  },
  {
    title: 'Marketplace',
    href: '/marketplace',
    description: 'Install public component templates and later publish your own reusable profile blocks.',
    action: 'Browse marketplace',
  },
];

function Social() {
  return (
    <>
      <SEO title="Social" />
      <section className="page-heading">
        <p className="eyebrow">Social hub</p>
        <h1>Share intentionally, not everywhere by default.</h1>
        <p>Friend access and the marketplace live together because both affect what you share beyond yourself.</p>
      </section>
      <section className="feature-grid hub-grid two-column-grid">
        {socialActions.map((item) => (
          <article className="surface-card" key={item.href}>
            <p className="tag">Social</p>
            <h2>{item.title}</h2>
            <p>{item.description}</p>
            <Link className="button button-secondary" to={item.href}>{item.action}</Link>
          </article>
        ))}
      </section>
    </>
  );
}

export default Social;
